var React = require('react');

function IcDollar (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.39 7.9C4.12 7.31 3.39 6.7 3.39 5.75C3.39 4.66 4.4 3.9 6.09 3.9C7.87 3.9 8.53 4.75 8.59 6H10.8C10.73 4.28 9.68 2.7 7.59 2.19V0H4.59V2.16C2.65 2.58 1.09 3.84 1.09 5.77C1.09 8.08 3 9.23 5.79 9.9C8.29 10.5 8.79 11.38 8.79 12.31C8.79 13 8.3 14.1 6.09 14.1C4.03 14.1 3.22 13.18 3.11 12H0.910004C1.03 14.19 2.67 15.42 4.59 15.83V18H7.59V15.85C9.54 15.48 11.09 14.35 11.09 12.3C11.09 9.46 8.66 8.49 6.39 7.9Z","fill":"currentColor"}));
}

IcDollar.defaultProps = {"width":"12","height":"18","viewBox":"0 0 12 18","fill":"none"};

module.exports = IcDollar;

IcDollar.default = IcDollar;
